export default {
  labels: {
    order: 'Ordre',
    customer: 'Kunde',
  },
  tags: {
    new_customer: 'Ny kunde',
    loyal_customer: 'Loyal kunde',
  },
};
